module.exports = __webpack_public_path__ + "img/profile-ignacio.34ef979d.webp";